import {
  Box,
  Flex,
  FlexProps,
  HStack,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
} from '@chakra-ui/react';
import { useResourceRelationship } from 'datx-jsonapi-react';
import { FC } from 'react';

import NotificationIcon from '@/assets/icons/ic-notification.svg';
import PeopleIcon from '@/assets/icons/ic-people.svg';

import { PopoverButton } from '@/components/ui/core/PopoverButton/PopoverButton';
import { ChatPopup } from '@/components/ui/shared/chat/ChatPopup/ChatPopup';
import { NotificationBadge } from '@/components/ui/shared/notifications/NotificationBadge/NotificationBadge';
import { Notifications } from '@/components/ui/shared/notifications/Notifications/Notifications';
import { ErrorFallback } from '@/components/ui/shared/overlays/ErrorFallback/ErrorFallback';
import { BugsnagErrorBoundary } from '@/components/ui/shared/utilities/BugsnagErrorBoundary/BugsnagErrorBoundary';
import { ResourceType } from '@/enums/ResourceType';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';
import { queryThinEventConfigurationRelationship } from '@/queries/thin-events';
import { EventConfiguration } from '@/resources/EventConfiguration';

// const DynamicDirectMessaging = dynamic(
//   () =>
//     import('@/components/ui/shared/direct-messaging/DirectMessaging/DirectMessaging').then(
//       (mod) => mod.DirectMessaging
//     ),
//   {
//     ssr: false,
//     loading: () => (
//       <Flex alignItems="center" justifyContent="center" h="full">
//         <CircleLoader size="lg" color="gray.200" />
//       </Flex>
//     ),
//   }
// );

interface ISecondaryMenuDesktopProps extends FlexProps {
  headerHeight?: number;
  popoverBottomOffset?: number;
}

export const SecondaryMenuDesktop: FC<ISecondaryMenuDesktopProps> = ({
  headerHeight,
  popoverBottomOffset = 16,
  ...rest
}) => {
  const { eventId } = useQueryParams<{ eventId: string }>({
    eventId: StringParam,
  });

  const { data: eventConfiguration } = useResourceRelationship<EventConfiguration>(
    queryThinEventConfigurationRelationship(eventId)
  );

  return (
    <Flex {...rest}>
      <HStack spacing={0}>
        {eventConfiguration.directMessaging && (
          <Popover variant="nav" isLazy placement="bottom-end">
            <PopoverTrigger>
              <PopoverButton variant="nav">
                <NotificationBadge refreshInterval={30_000} resourceType={ResourceType.EventChatChannel}>
                  <PeopleIcon />
                </NotificationBadge>
              </PopoverButton>
            </PopoverTrigger>
            <PopoverContent h="calc(100vh - 80px)" maxH="800px">
              <PopoverBody>
                <BugsnagErrorBoundary FallbackComponent={ErrorFallback}>
                  <ChatPopup />
                </BugsnagErrorBoundary>
              </PopoverBody>
            </PopoverContent>
          </Popover>
        )}

        <Popover variant="nav" isLazy placement="bottom-end">
          <PopoverTrigger>
            <PopoverButton variant="nav">
              <NotificationBadge resourceType={ResourceType.Lecture}>
                <NotificationIcon />
              </NotificationBadge>
            </PopoverButton>
          </PopoverTrigger>
          <Portal>
            <PopoverContent h="calc(100vh - 80px)" maxH="800px">
              <PopoverBody>
                <BugsnagErrorBoundary FallbackComponent={ErrorFallback}>
                  <Notifications />
                </BugsnagErrorBoundary>
              </PopoverBody>
            </PopoverContent>
          </Portal>
        </Popover>
      </HStack>
    </Flex>
  );
};
